import { Injectable } from "@angular/core";
import { DateTime } from "luxon";

@Injectable({
  providedIn: "root",
})
export class EstonianTimezoneService {

  private readonly ESTONIAN_TIMEZONE = "Europe/Tallinn";

  /**
   * Get current hour in Estonian timezone (0-23)
   * @returns number representing current hour
   */
  getCurrentEstonianHour(): number {
    return DateTime.now().setZone(this.ESTONIAN_TIMEZONE).hour;
  }

  /**
   * Get current day of week in Estonian timezone (0-6, where 0 is Sunday)
   * @returns number representing current day of week
   */
  getCurrentEstonianDayOfWeek(): number {
    return DateTime.now().setZone(this.ESTONIAN_TIMEZONE).weekday % 7; // Convert to 0-6 format (Sunday = 0)
  }
}
